module.exports = __webpack_public_path__ + "static/amamentacao-mobile-df9c66ebca9dbbbc25e6452622cdf7d3.png";